import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { Select } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
import { Menu } from "components/bootstrap";
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const HiddenButton = styled.button`
  visibility: hidden;
  height: 0;
  padding: 0;
  border: 0;
`;
const FilterSelect = ({ filterComponents, columnTitle, onCreate, selectedFilters }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("widgets");
  const container = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [createValue, setCreateValue] = useState();
  const filterComponent = selectedColumn ? filterComponents.find(({ attribute }) => attribute === selectedColumn) : void 0;
  const selectedValues = selectedColumn ? (_a = selectedFilters.find(({ field }) => field === selectedColumn)) == null ? void 0 : _a.value : [];
  const filterOptions = useMemo(
    () => filterComponents.map((filtComp) => ({
      value: filtComp.attribute,
      label: columnTitle(filtComp.attribute),
      disabled: !filtComp.allowMultipleValues && !!selectedFilters.find(({ field }) => field === filtComp.attribute)
    })).sort(({ label: label1 }, { label: label2 }) => defaultCompare(label1, label2)),
    [columnTitle, filterComponents, selectedFilters]
  );
  const onSelectColumn = (selectedCol) => {
    setSelectedColumn(selectedCol);
    setOpen(true);
  };
  const onSubmit = (column, val) => {
    if (val) {
      onCreate(column, val);
    }
    setOpen(false);
    setSelectedColumn(null);
    setCreateValue(null);
  };
  const onClose = () => {
    onSubmit(selectedColumn, createValue);
  };
  const onChange = (newValue, shouldSubmit = true) => {
    var _a2, _b2;
    const normalizedValue = (_b2 = (_a2 = filterComponent == null ? void 0 : filterComponent.valueForConfig) == null ? void 0 : _a2.call(filterComponent, newValue)) != null ? _b2 : newValue;
    if (shouldSubmit) {
      onSubmit(selectedColumn, normalizedValue);
    } else {
      setCreateValue(normalizedValue);
    }
  };
  return /* @__PURE__ */ React.createElement(Container, { ref: container }, /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "filter-select",
      placeholder: t("overview_configuration.configure_filter"),
      "aria-label": t("overview_configuration.configure_filter"),
      options: filterOptions,
      clearable: false,
      size: "small",
      onChange: (selectedCol) => onSelectColumn(selectedCol),
      value: selectedColumn
    }
  ), /* @__PURE__ */ React.createElement(
    Menu,
    {
      position: "bottom-start",
      withinPortal: true,
      onClose,
      opened: open,
      width: (_b = container == null ? void 0 : container.current) == null ? void 0 : _b.offsetWidth
    },
    /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(HiddenButton, { type: "button" })),
    /* @__PURE__ */ React.createElement(Menu.Dropdown, null, filterComponent == null ? void 0 : filterComponent.configuration(
      selectedValues != null ? selectedValues : [],
      (_d = (_c = filterComponent == null ? void 0 : filterComponent.valueFromConfig) == null ? void 0 : _c.call(filterComponent, createValue)) != null ? _d : createValue,
      onChange
    ))
  ));
};
export default FilterSelect;
